import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useDismissAfterHoursBanner(): UseMutationResult<
  Response,
  Error,
  void
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiClient
        .url("/users/me")
        .patch({ afterHoursBannerDismissed: true })
        .res(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
